import { render, staticRenderFns } from "./TpmTsdOpcConfigTtcList.vue?vue&type=template&id=09d2bc0a&"
import script from "./TpmTsdOpcConfigTtcList.vue?vue&type=script&lang=js&"
export * from "./TpmTsdOpcConfigTtcList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports